<template>
  <a class="link-instagram" target="_blank" :href="`https://www.instagram.com/${pseudo}`">
    <span class="link-instagram-pseudo">@{{ pseudo }}</span>
    <p class="link-instagram-name">{{ name }}</p>
  </a>
</template>

<script>
export default {
  name: 'LinkInstagram',
  props: {
    pseudo: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.link-instagram {
  display: inline-block;
  margin-right: 1rem;

  &-pseudo {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.1rem;
  }

  &-name {
    @extend %font-bold;

    font-size: 0.8rem;
  }
}
</style>